export default {
  namespaced: true,
  state: {
    dateOnFoodTrackerScreen: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().slice(0, -1).split('T')[0],
    dateTypeOnFoodTrackerScreen: 'day',
    mealType: '',
  },
  getters: {
  },
  mutations: {
    setDateOnFoodTrackerScreen(state, data) {
      state.dateOnFoodTrackerScreen = data;
    },
    setDateTypeOnFoodTrackerScreen(state, data) {
      state.dateTypeOnFoodTrackerScreen = data;
    },
    setMealType(state, mealType) {
      state.mealType = mealType;
    }
  },
  actions: {
    initializeSelectionsOnFoodTrackerScreen({dispatch}) {
      const today = (new Date).toISOString().split('T')[0];
      dispatch('setDateOnFoodTrackerScreen', today);
      dispatch('setDateTypeOnFoodTrackerScreen', 'day');
    },
    setDateOnFoodTrackerScreen({commit}, data) {
      commit('setDateOnFoodTrackerScreen', data);
    },
    setDateTypeOnFoodTrackerScreen({commit}, data) {
      commit('setDateTypeOnFoodTrackerScreen', data);
    },
    setMealType({ commit }, data) {
      commit('setMealType', data);
    }
  },
}